import React, { memo } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import "./AxiomMultiSelectCheckboxes.scss";

function AxiomMultiSelectCheckboxes(props) {
  return (
    <div className={"axiom-multi-select-checkbox"}>
      <ReactMultiSelectCheckboxes
        onInputChange={(val) => (props.onInputChange ? props.onInputChange(props.name, val) : null)}
        maxWidth={props.maxWidth ? props.maxWidth : 200}
        minWidth={props.minWidth ? props.minWidth : 100}
        maxMenuHeight={props.maxMenuHeight ? props.maxMenuHeight : 200}
        minItemsForSearch={props.minItemsForSearch ? props.minItemsForSearch : 25}
        onChange={(selectedOption) =>
          props.onChange ? props.onChange(props.name, selectedOption) : null
        }
        placeholderButtonLabel={
          props.placeholderButtonLabel ? props.placeholderButtonLabel : "Select..."
        }
        options={props.options}
        placeholder={props.placeholder ? props.placeholder : ""}
        value={props.value}
      />
    </div>
  );
}

export default memo(AxiomMultiSelectCheckboxes);
